module.exports = __webpack_public_path__ + "static/media/translator.4db810d4.jpg";